var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass:
        "icon-details-add-styling margin-bottom-2xl laptop:margin-top-2xl laptop:margin-bottom-0",
      staticStyle: {
        "--color-input-min-width": "var(--icon-details-input-color-min-width)",
      },
      attrs: { id: "icon-add-styling", action: "" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "icon-details-styling-color",
          staticStyle: {
            "--input-padding": "var(--spacing-xs)",
            "--input-border-color": "var(--fa-gravy)",
            "--input-box-shadow": "none",
            gap: "var(--spacing-3xs)",
          },
        },
        [
          _c(
            "div",
            { staticClass: "size-xs padding-right-md padding-bottom-xs" },
            [
              _c(
                "span",
                {
                  staticClass: "text-uppercase padding-right-sm",
                  staticStyle: {
                    "letter-spacing": "var(--letter-spacing-3xl)",
                    "font-weight": "var(--font-weight-black)",
                  },
                },
                [_vm._v("Color")]
              ),
              _vm._v(" "),
              _vm.isDuotoneFamily(_vm.styling.family)
                ? _c(
                    "site-link",
                    {
                      staticStyle: { "--link-color": "var(--fa-gravy)" },
                      attrs: {
                        to: _vm.$docs("/web/style/color"),
                        "aria-label":
                          "Use our custom color and opacity CSS properties too adjust the color of Duotone icon layers. Click to learn more",
                        "data-balloon-pos": "right",
                        "data-balloon-length": "xlarge",
                      },
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: {
                          icon: _vm.$v6.solid.faInfoCircle,
                          "fixed-width": "",
                          size: "lg",
                        },
                      }),
                    ],
                    1
                  )
                : _c(
                    "site-link",
                    {
                      staticStyle: { "--link-color": "var(--fa-gravy)" },
                      attrs: {
                        to: _vm.$docs("/web/style/color"),
                        "aria-label":
                          "Use basic CSS style to add color to an icon. Click to learn more",
                        "data-balloon-pos": "right",
                        "data-balloon-length": "xlarge",
                      },
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: {
                          icon: _vm.$v6.solid.faInfoCircle,
                          "fixed-width": "",
                        },
                      }),
                    ],
                    1
                  ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.isDuotoneFamily(_vm.styling.family)
            ? [
                _c(
                  "ul",
                  {
                    staticClass:
                      "custom-radio-button-set display-flex align-stretch",
                    staticStyle: {
                      "--list-style-type": "none",
                      "--padding-left": "0",
                      "--list-margin-top": "0",
                      "flex-grow": "1",
                      gap: "var(--spacing-xs)",
                    },
                  },
                  [
                    _c("li", [
                      _c(
                        "label",
                        {
                          staticClass: "margin-0 padding-y-xs padding-x-sm",
                          staticStyle: {
                            "border-radius": "var(--border-radius-md)",
                            "flex-grow": "0",
                            "background-color": "var(--fa-lt-gravy)",
                          },
                          attrs: {
                            for: "color-none",
                            "aria-label": "Remove Coloring",
                            "data-balloon-pos": "up",
                          },
                        },
                        [
                          _c("font-awesome-icon", {
                            staticStyle: { "vertical-align": "middle" },
                            attrs: {
                              icon: _vm.$v6.solid.faBan,
                              "fixed-width": "",
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "sr-only" }, [
                            _vm._v("Default Color"),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("input", {
                        staticStyle: {
                          appearance: "none",
                          position: "absolute",
                          "box-shadow": "none",
                        },
                        attrs: {
                          id: "color-none",
                          type: "radio",
                          name: "icon-color",
                          value: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.resetDuotone()
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        style: _vm.primaryColorStyle,
                        attrs: {
                          "aria-label": "Primary Color",
                          "data-balloon-pos": "up",
                        },
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "sr-only",
                            attrs: { for: "styling-color-primary" },
                          },
                          [
                            _vm._v(
                              "\n            Icon Primary Color\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          staticClass: "styling-color-input margin-bottom-0",
                          staticStyle: {
                            "--input-padding": "var(--spacing-4xs)",
                            "min-width": "var(--color-input-min-width)",
                          },
                          attrs: { id: "styling-color-primary", type: "color" },
                          domProps: { value: _vm.styling.colorPrimary },
                          on: {
                            change: (event) =>
                              _vm.change("colorPrimary", event.target.value),
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass:
                              "input-color-shim tablet:display-none position-relative z--1",
                            staticStyle: { opacity: "0" },
                            attrs: { "aria-hidden": "true" },
                          },
                          [_vm._v("Choose a color")]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.isDuotoneFamily(_vm.styling.family)
                      ? _c(
                          "li",
                          {
                            staticStyle: {
                              "max-width": "4rem",
                              "margin-right": "var(--spacing-4xs)",
                            },
                            attrs: {
                              "aria-label": "Primary Opacity",
                              "data-balloon-pos": "up",
                            },
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "sr-only",
                                attrs: { for: "styling-color-primary-opacity" },
                              },
                              [
                                _vm._v(
                                  "\n            Icon Primary Opacity\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              staticClass:
                                "styling-color-input simple margin-bottom-0 text-center",
                              attrs: {
                                id: "styling-color-primary-opacity",
                                type: "number",
                                placeholder: "0 to 1.0",
                                min: "0",
                                max: "1.0",
                                step: "0.1",
                              },
                              domProps: { value: _vm.styling.opacityPrimary },
                              on: {
                                input: (event) =>
                                  _vm.change(
                                    "opacityPrimary",
                                    event.target.value
                                  ),
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        staticClass: "margin-left-3xs",
                        staticStyle: { "flex-grow": "1" },
                        attrs: {
                          "aria-label": "Secondary Color",
                          "data-balloon-pos": "up",
                        },
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "sr-only",
                            attrs: { for: "styling-color-secondary" },
                          },
                          [
                            _vm._v(
                              "\n            Icon Secondary Color\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          staticClass: "styling-color-input margin-bottom-0",
                          style: `--input-padding: var(--spacing-4xs); min-width: var(--color-input-min-width)`,
                          attrs: {
                            id: "styling-color-secondary",
                            type: "color",
                          },
                          domProps: { value: _vm.styling.colorSecondary },
                          on: {
                            change: (event) =>
                              _vm.change("colorSecondary", event.target.value),
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass:
                              "input-color-shim tablet:display-none position-relative z--1",
                            staticStyle: { opacity: "0" },
                            attrs: { "aria-hidden": "true" },
                          },
                          [_vm._v("Choose a color")]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        staticStyle: { "max-width": "4rem" },
                        attrs: {
                          "aria-label": "Secondary Opacity",
                          "data-balloon-pos": "up",
                        },
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "sr-only",
                            attrs: { for: "styling-color-secondary-opacity" },
                          },
                          [
                            _vm._v(
                              "\n            Icon Secondary Opacity\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          staticClass:
                            "styling-color-input simple margin-bottom-0 text-center",
                          attrs: {
                            id: "styling-color-secondary-opacity",
                            type: "number",
                            min: "0",
                            max: "1.0",
                            step: "0.1",
                            placeholder: "0 to 1.0",
                          },
                          domProps: { value: _vm.styling.opacitySecondary },
                          on: {
                            input: (event) =>
                              _vm.change(
                                "opacitySecondary",
                                event.target.value
                              ),
                          },
                        }),
                      ]
                    ),
                  ]
                ),
              ]
            : [
                _c(
                  "ul",
                  {
                    staticClass:
                      "custom-radio-button-set display-flex align-stretch",
                    staticStyle: {
                      "--list-style-type": "none",
                      "--padding-left": "0",
                      "--list-margin-top": "0",
                      "flex-grow": "1",
                      gap: "var(--spacing-xs)",
                    },
                  },
                  [
                    _vm._l(_vm.iconColors, function (colorSelect) {
                      return _c(
                        "li",
                        {
                          key: colorSelect.label,
                          staticClass: "position-relative",
                          style: _vm.radioCustomStyles(colorSelect.color),
                        },
                        [
                          colorSelect.color === null
                            ? [
                                _c("input", {
                                  staticStyle: {
                                    appearance: "none",
                                    position: "absolute",
                                    "box-shadow": "none",
                                  },
                                  attrs: {
                                    id: "color-none",
                                    type: "radio",
                                    name: "icon-color",
                                    value: "",
                                  },
                                  domProps: {
                                    checked:
                                      colorSelect.color ===
                                      _vm.styling.colorPrimary,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.colorReset("colorPrimary")
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass:
                                      "styling-color-input margin-0 padding-y-xs padding-x-sm",
                                    staticStyle: {
                                      "border-radius":
                                        "var(--border-radius-md)",
                                      "flex-grow": "0",
                                      "background-color": "var(--fa-lt-gravy)",
                                    },
                                    attrs: {
                                      for: "color-none",
                                      "aria-label": "Remove Coloring",
                                      "data-balloon-pos": "up",
                                    },
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      staticStyle: {
                                        "vertical-align": "middle",
                                      },
                                      attrs: {
                                        icon: _vm.$v6.solid.faBan,
                                        "fixed-width": "",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "sr-only" }, [
                                      _vm._v("Default Color"),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            : [
                                _c("input", {
                                  staticStyle: {
                                    appearance: "none",
                                    position: "absolute",
                                    "box-shadow": "none",
                                  },
                                  attrs: {
                                    id: `color-${colorSelect.label}`,
                                    type: "radio",
                                    name: "icon-color",
                                  },
                                  domProps: {
                                    value: colorSelect.color,
                                    checked:
                                      colorSelect.color ===
                                      _vm.styling.colorPrimary,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.change(
                                        "colorPrimary",
                                        colorSelect.color
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass:
                                      "styling-color-input margin-0 padding-4xs",
                                    staticStyle: {
                                      "border-radius":
                                        "var(--border-radius-md)",
                                      "flex-grow": "1",
                                    },
                                    attrs: {
                                      for: `color-${colorSelect.label}`,
                                      "aria-label": `Color it ${colorSelect.label}`,
                                      "data-balloon-pos": "up",
                                    },
                                  },
                                  [
                                    _c("span", {
                                      staticClass: "display-inline-block",
                                      style: `height: 100%;width: 100%;border-radius: var(--border-radius-sm);vertical-align: middle;background-color: ${colorSelect.color};`,
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "sr-only" }, [
                                      _vm._v(_vm._s(colorSelect.label)),
                                    ]),
                                  ]
                                ),
                              ],
                        ],
                        2
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        class: `position-relative ${
                          _vm.hasCustomColor ? "active" : ""
                        }`,
                        style: _vm.radioCustomStyles(),
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "sr-only",
                            staticStyle: { border: "0" },
                            attrs: {
                              for: "color-custom",
                              "aria-label": "Pick your own color",
                              "data-balloon-pos": "up",
                            },
                          },
                          [
                            _c("input", {
                              staticClass: "sr-only",
                              attrs: {
                                id: "color-custom",
                                type: "radio",
                                name: "icon-color",
                                value: "color-custom",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.openCustomColor()
                                },
                              },
                            }),
                            _vm._v(
                              "\n            Pick Your Own Color\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          ref: "colorCustom",
                          staticClass: "margin-bottom-0",
                          staticStyle: {
                            appearance: "none",
                            position: "absolute",
                            "box-shadow": "none",
                            "--input-padding": "var(--spacing-4xs)",
                            height: "100%",
                            "min-width": "var(--color-input-min-width)",
                            opacity: "0",
                          },
                          attrs: { id: "color-custom", type: "color" },
                          domProps: { value: _vm.styling.colorPrimary },
                          on: {
                            change: (event) =>
                              _vm.change("colorPrimary", event.target.value),
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass:
                              "styling-color-input margin-0 padding-4xs",
                            staticStyle: {
                              "border-radius": "var(--border-radius-md)",
                              "flex-grow": "1",
                            },
                            attrs: {
                              for: "color-custom",
                              "aria-label": "Pick your own color",
                              "data-balloon-pos": "up",
                            },
                          },
                          [
                            _c("span", {
                              staticClass: "display-inline-block",
                              style: _vm.colorCustomStyles,
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "sr-only" }, [
                              _vm._v("Pick a color"),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ],
                  2
                ),
              ],
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "icon-details-styling-size" }, [
        _c(
          "div",
          { staticClass: "size-xs padding-right-md padding-bottom-xs" },
          [
            _c(
              "span",
              {
                staticClass: "text-uppercase padding-right-sm",
                staticStyle: {
                  "letter-spacing": "var(--letter-spacing-3xl)",
                  "font-weight": "var(--font-weight-black)",
                },
              },
              [_vm._v("Size")]
            ),
            _c(
              "site-link",
              {
                staticStyle: { "--link-color": "var(--fa-gravy)" },
                attrs: {
                  to: _vm.$docs("/web/style/size"),
                  "aria-label":
                    "With our web toolkit, you can easily size an icon with a CSS class. Click to learn more",
                  "data-balloon-pos": "right",
                  "data-balloon-length": "xlarge",
                },
              },
              [
                _c("font-awesome-icon", {
                  attrs: {
                    icon: _vm.$v6.solid.faInfoCircle,
                    "fixed-width": "",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "ul",
          {
            staticClass: "custom-radio-button-set display-flex align-stretch",
            staticStyle: {
              "--list-style-type": "none",
              "--padding-left": "0",
              "--list-margin-top": "0",
              "flex-grow": "1",
              gap: "var(--spacing-xs)",
            },
          },
          _vm._l(_vm.iconSizes, function (sizeSelect) {
            return _c(
              "li",
              {
                key: sizeSelect.name,
                staticClass: "position-relative",
                style: _vm.radioCustomStyles(sizeSelect.value),
              },
              [
                sizeSelect.value === null
                  ? [
                      _c("input", {
                        staticStyle: {
                          appearance: "none",
                          position: "absolute",
                          "box-shadow": "none",
                        },
                        attrs: {
                          id: "size-none",
                          type: "radio",
                          name: "icon-size",
                          value: "",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.change("size", sizeSelect.value)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "margin-0 padding-y-xs padding-x-sm",
                          staticStyle: {
                            "border-radius": "var(--border-radius-md)",
                            "flex-grow": "0",
                            "background-color": "var(--fa-lt-gravy)",
                          },
                          attrs: {
                            for: "size-none",
                            "aria-label": "Remove Sizing",
                            "data-balloon-pos": "up",
                          },
                        },
                        [
                          _c("font-awesome-icon", {
                            staticStyle: { "vertical-align": "middle" },
                            attrs: {
                              icon: _vm.$v6.solid.faBan,
                              "fixed-width": "",
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "sr-only" }, [
                            _vm._v(_vm._s(sizeSelect.name)),
                          ]),
                        ],
                        1
                      ),
                    ]
                  : [
                      _c("input", {
                        staticStyle: {
                          appearance: "none",
                          position: "absolute",
                          "box-shadow": "none",
                        },
                        attrs: {
                          id: `size-${sizeSelect.value}`,
                          type: "radio",
                          name: "icon-size",
                        },
                        domProps: {
                          value: sizeSelect.value,
                          checked: sizeSelect.value === _vm.styling.size,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.change("size", sizeSelect.value)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "margin-0 padding-y-xs padding-x-sm",
                          staticStyle: {
                            "border-radius": "var(--border-radius-md)",
                            "flex-grow": "1",
                          },
                          attrs: { for: `size-${sizeSelect.value}` },
                        },
                        [_c("span", [_vm._v(_vm._s(sizeSelect.name))])]
                      ),
                    ],
              ],
              2
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          class: `icon-details-styling-rotate position-relative ${
            _vm.hasAnimation ? "disabled" : ""
          }`,
        },
        [
          _vm.hasAnimation
            ? _c("span", {
                staticStyle: {
                  position: "absolute",
                  inset: "0",
                  cursor: "not-allowed",
                },
                attrs: {
                  "aria-label": "Can't rotate while animating",
                  "data-balloon-pos": "up-left",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "size-xs padding-right-md padding-bottom-xs" },
            [
              _c(
                "span",
                {
                  staticClass: "text-uppercase padding-right-sm",
                  staticStyle: {
                    "letter-spacing": "var(--letter-spacing-3xl)",
                    "font-weight": "var(--font-weight-black)",
                  },
                },
                [_vm._v("Rotate")]
              ),
              _c(
                "site-link",
                {
                  staticStyle: { "--link-color": "var(--fa-gravy)" },
                  attrs: {
                    to: _vm.$docs("/web/style/rotate"),
                    "aria-label":
                      "With our web toolkit, you can easily rotate an icon with a CSS class. Click to learn more",
                    "data-balloon-pos": "right",
                    "data-balloon-length": "xlarge",
                  },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: {
                      icon: _vm.$v6.solid.faInfoCircle,
                      "fixed-width": "",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "ul",
            {
              class: `custom-radio-button-set display-flex align-stretch ${
                _vm.hasAnimation ? "disabled" : ""
              }`,
              staticStyle: {
                "--list-style-type": "none",
                "--padding-left": "0",
                "--list-margin-top": "0",
                "flex-grow": "1",
                gap: "var(--spacing-xs)",
              },
            },
            [
              _vm._l(_vm.iconRotations, function (rotateSelect) {
                return _c(
                  "li",
                  {
                    key: rotateSelect.name,
                    staticClass: "position-relative",
                    style: _vm.radioCustomStyles(rotateSelect.value),
                    on: {
                      click: function ($event) {
                        return _vm.change("rotation", rotateSelect.value)
                      },
                    },
                  },
                  [
                    rotateSelect.value === null
                      ? [
                          _c("input", {
                            staticStyle: {
                              appearance: "none",
                              position: "absolute",
                              "box-shadow": "none",
                            },
                            attrs: {
                              id: "rotate-none",
                              type: "radio",
                              name: "icon-rotate",
                              value: "",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "margin-0 padding-y-xs padding-x-sm",
                              staticStyle: {
                                "border-radius": "var(--border-radius-md)",
                                "flex-grow": "0",
                                "background-color": "var(--fa-lt-gravy)",
                              },
                              attrs: {
                                for: "rotate-none",
                                "aria-label": "Remove Rotation",
                                "data-balloon-pos": "up",
                              },
                            },
                            [
                              _c("font-awesome-icon", {
                                staticStyle: { "vertical-align": "middle" },
                                attrs: {
                                  icon: _vm.$v6.solid.faBan,
                                  "fixed-width": "",
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "sr-only" }, [
                                _vm._v(_vm._s(rotateSelect.name)),
                              ]),
                            ],
                            1
                          ),
                        ]
                      : [
                          _c("input", {
                            staticStyle: {
                              appearance: "none",
                              position: "absolute",
                              "box-shadow": "none",
                            },
                            attrs: {
                              id: `${rotateSelect.value}`,
                              type: "radio",
                              name: "icon-rotate",
                            },
                            domProps: {
                              value: rotateSelect.value,
                              checked:
                                rotateSelect.value === _vm.styling.rotation,
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "margin-0 padding-y-xs padding-x-sm",
                              staticStyle: {
                                "border-radius": "var(--border-radius-md)",
                                "flex-grow": "1",
                              },
                              attrs: {
                                for: `${rotateSelect.value}`,
                                "aria-label": `Rotate ${rotateSelect.name}deg to the right`,
                                "data-balloon-pos": "up",
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(rotateSelect.name) + "°"),
                              ]),
                            ]
                          ),
                        ],
                  ],
                  2
                )
              }),
              _vm._v(" "),
              _c(
                "li",
                {
                  class: `position-relative ${
                    _vm.hasCustomRotation ? "active" : ""
                  }`,
                  staticStyle: {
                    "padding-right": "var(--spacing-4xs)",
                    "flex-grow": "1",
                    display: "flex",
                    "text-align": "center",
                  },
                },
                [
                  _c("input", {
                    ref: "rotateCustom",
                    staticClass: "sr-only",
                    attrs: {
                      id: "rotate-custom",
                      type: "radio",
                      name: "icon-rotate",
                      value: "rotate-custom",
                    },
                    domProps: {
                      checked: _vm.customRotation === _vm.styling.rotation,
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "sr-only margin-0 padding-y-xs padding-x-sm",
                      attrs: { for: "rotate-custom" },
                    },
                    [_vm._v("\n          Rotate custom\n        ")]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    staticClass: "margin-0 text-center",
                    staticStyle: {
                      "flex-grow": "1",
                      "--input-border-color": "var(--fa-lt-gravy)",
                      "--input-padding": "var(--spacing-xs) var(--spacing-sm)",
                      "--input-box-shadow": "none",
                    },
                    attrs: {
                      id: "rotate-custom",
                      type: "number",
                      size: "5",
                      name: "icon-rotate-custom",
                      placeholder: "Custom...",
                    },
                    domProps: { value: _vm.customRotation },
                    on: {
                      change: (event) =>
                        _vm.applyCustomRotation(event.target.value),
                    },
                  }),
                ]
              ),
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: `icon-details-styling-flip position-relative ${
            _vm.hasAnimation ? "disabled" : ""
          }`,
        },
        [
          _vm.hasAnimation
            ? _c("span", {
                staticStyle: {
                  position: "absolute",
                  inset: "0",
                  cursor: "not-allowed",
                },
                attrs: {
                  "aria-label": "Can't flip while animating",
                  "data-balloon-pos": "up-left",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "size-xs padding-right-md padding-bottom-xs" },
            [
              _c(
                "span",
                {
                  staticClass: "text-uppercase padding-right-sm",
                  staticStyle: {
                    "letter-spacing": "var(--letter-spacing-3xl)",
                    "font-weight": "var(--font-weight-black)",
                  },
                },
                [_vm._v("Flip")]
              ),
              _c(
                "site-link",
                {
                  staticStyle: { "--link-color": "var(--fa-gravy)" },
                  attrs: {
                    to: _vm.$docs("/web/style/rotate"),
                    "aria-label":
                      "With our web toolkit, you can easily flip an icon with a CSS class. Click to learn more",
                    "data-balloon-pos": "right",
                    "data-balloon-length": "xlarge",
                  },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: {
                      icon: _vm.$v6.solid.faInfoCircle,
                      "fixed-width": "",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "ul",
            {
              class: `custom-radio-button-set display-flex align-stretch ${
                _vm.hasAnimation ? "disabled" : ""
              }`,
              staticStyle: {
                "--list-style-type": "none",
                "--padding-left": "0",
                "--list-margin-top": "0",
                "flex-grow": "1",
                gap: "var(--spacing-xs)",
              },
            },
            _vm._l(_vm.iconFlips, function (flipSelect) {
              return _c(
                "li",
                {
                  key: flipSelect.name,
                  staticClass: "position-relative",
                  style: _vm.radioCustomStyles(flipSelect.value),
                  on: {
                    click: function ($event) {
                      return _vm.change("rotation", flipSelect.value)
                    },
                  },
                },
                [
                  flipSelect.value === null
                    ? [
                        _c("input", {
                          staticStyle: {
                            appearance: "none",
                            position: "absolute",
                            "box-shadow": "none",
                          },
                          attrs: {
                            id: "flip-none",
                            type: "radio",
                            name: "icon-flip",
                            value: "",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "margin-0 padding-y-xs padding-x-sm",
                            staticStyle: {
                              "border-radius": "var(--border-radius-md)",
                              "flex-grow": "0",
                              "background-color": "var(--fa-lt-gravy)",
                            },
                            attrs: {
                              for: "flip-none",
                              "aria-label": "Remove Flipping",
                              "data-balloon-pos": "up",
                            },
                          },
                          [
                            _c("font-awesome-icon", {
                              staticStyle: { "vertical-align": "middle" },
                              attrs: {
                                icon: _vm.$v6.solid.faBan,
                                "fixed-width": "",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "sr-only" }, [
                              _vm._v(_vm._s(flipSelect.name)),
                            ]),
                          ],
                          1
                        ),
                      ]
                    : [
                        _c("input", {
                          staticStyle: {
                            appearance: "none",
                            position: "absolute",
                            "box-shadow": "none",
                          },
                          attrs: {
                            id: `${flipSelect.id}`,
                            type: "radio",
                            name: "icon-flip",
                          },
                          domProps: {
                            value: flipSelect.value,
                            checked: flipSelect.value === _vm.styling.rotation,
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "margin-0 padding-y-xs padding-x-sm",
                            staticStyle: {
                              "border-radius": "var(--border-radius-md)",
                              "flex-grow": "1",
                            },
                            attrs: {
                              for: `${flipSelect.id}`,
                              "aria-label": `${flipSelect.name}`,
                              "data-balloon-pos": "up",
                            },
                          },
                          [
                            _c("font-awesome-icon", {
                              attrs: {
                                icon: _vm.$v6[flipSelect.family][
                                  flipSelect.icon
                                ],
                                size: "lg",
                                "fixed-width": "",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "sr-only" }, [
                              _vm._v(_vm._s(flipSelect.name)),
                            ]),
                          ],
                          1
                        ),
                      ],
                ],
                2
              )
            }),
            0
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }